import React, { useState } from "react";
import Container from "../../../components/Container/Container";
import CustomButton from "../../../components/commons/CustomBtn";
import CustomDropdown from "../../../components/commons/CustomDropDown";
import Filters from "../../immobilier/componnents/Filter";
import { ReactComponent as Task } from "../../../components/assets/tache.svg";
import { ReactComponent as Phone } from "../../../components/assets/phone.svg";
import { ReactComponent as Calender } from "../../../components/assets/calender.svg";

const ActiviteHeader = ({
  activeView,
  setActiveView,
  carte = true,
  filter = true,
}) => {
  const applyFilters = (filters) => {};
  const [checkBox, setCheckBox] = useState(false);

  const resetFilters = () => {
    console.log("Filters reset");
  };
  const dropdownOptions = [
    { value: "tout", label: "Tout" },
    { value: "elevee", label: "Élevée" },
    { value: "moyenne", label: "Moyenne" },
    { value: "faible", label: "Faible" },
  ];
  return (
    <div>
      <div className="d-flex bg-white radius5 headerContainer align-items-center justify-content-between">
        <div className="d-flex align-items-center gap10 bg-white radius5 px-20 py-2px searchBar">
          <img src="./icons/search.svg" alt="search" height={16} width={16} />
          <input
            type="search"
            placeholder="Recherche avancée"
            className="inputSearch border-0"
          />
        </div>
        <div className="d-flex align-items-center gap10">
          <input
            type="checkbox"
            name="mesactivites"
            id="mesactivites"
            checked={checkBox}
            onChange={() => setCheckBox(!checkBox)}
          />

          <label htmlFor="mesactivites">Mes activités uniquement</label>
        </div>
        <div className="headerButtons d-flex gap3 ">
          <CustomButton
            onClick={() => setActiveView("task")}
            label="Tâches"
            buttonClass={`
            ${
              activeView === "task"
                ? "whiteSvg bg-pink white radiusTL5 radiusBL5 px-20 py-10"
                : "bg-white-grey darkGrey radiusTL5 radiusBL5 px-20 py-10"
            }
          `}
            labelClass=" fs13 medium text-capitalize"
            icon={<Task />}
            iconClass="immoHeaderIcons"
          />
          <CustomButton
            onClick={() => setActiveView("phone")}
            label="Appels"
            buttonClass={`
            ${
              activeView === "phone"
                ? "whiteSvg bg-pink white  px-20 py-10"
                : "bg-white-grey darkGrey  px-20 py-10"
            }
          `}
            labelClass=" fs13 medium text-capitalize"
            icon={<Phone />}
            iconClass="immoHeaderIcons"
          />

          <CustomButton
            onClick={() => setActiveView("rdv")}
            label="RDV"
            buttonClass={`
            ${
              activeView === "rdv"
                ? "whiteSvg bg-pink white radiusTR5 radiusBR5 px-20 py-10"
                : "bg-white-grey darkGrey radiusBR5 radiusTR5 px-20 py-10"
            }
          `}
            labelClass=" fs13 medium text-capitalize"
            icon={<Calender />}
            iconClass="immoHeaderIcons"
          />
        </div>
        <div className="d-flex gap10 align-items-center dropdownMenu">
          <p>Trier par</p>
          <CustomDropdown options={dropdownOptions} />
        </div>
        {filter && (
          <div className="filter d-flex align-items-center gap10">
            <p>Filtrer</p>
            <Filters
              onApplyFilters={applyFilters}
              onResetFilters={resetFilters}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ActiviteHeader;
